// extracted by mini-css-extract-plugin
export var brand = "_2a-9";
export var compact = "_2a-6";
export var extraSmall = "_2a-7";
export var icon = "_2a-0";
export var large = "_2a-4";
export var light = "_2a-1";
export var medium = "_2a-5";
export var outline = "_2a-b";
export var primaryDark = "_2a-a";
export var primaryLight = "_2a-8";
export var primaryModern = "_2a-c";
export var success = "_2a-2";
export var successSolid = "_2a-3";